import Content1 from "../../../assets/images/projects/blibli-checkout-projects/content1.png";
import Content2 from "../../../assets/images/projects/blibli-checkout-projects/content2.png";
import Content3 from "../../../assets/images/projects/blibli-checkout-projects/content3.png";

import { ProjectDetailProps } from "../props";

export default {
  title: "Blibli Checkout & Promo",
  timeline: "",
  context:
    "Few features that released in Blibli’s Checkout that I worked and how it takes for Blibli and customer get. Disclaimer, this came with the ideas from Checkout team including the Product Manager, Tech, and not least from UX researcher.",
  team: [],
  thumbnail: "",
  contents: [
    {
      left: {
        title: "01. All Promo Page",
        content: (
          <div>
            <p>
              In Blibli there are many types promo for customers to obtained:
              promo code, coupon, or seller voucher. Focusing on the promo
              code’s behaviour, the promo code is not being communicated clear
              enough for the customer to understand that the quota is already
              exhausted. Customers often click on the copy button, paste it on
              the Checkout page, and then they'll get an error message saying
              the promo is out of quota. As a result, many customers dropped and
              experienced bad journey for the promo. Some of them refused to
              continue to buy.{" "}
            </p>

            <p>
              On that problem we tried to do improvement to give the alert and
              label for them to understand of the quota promo code better. We
              showed on how the promo whether it is available, will be valid on
              certain times, and out of quota. With this kind of solution, we
              succeeded to reduce the drop rate of the Checkout which are
              impacting to main major thing for Checkout.
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: <img alt="" src={Content1} width="100%" />,
      },
      bottomImage: "",
    },
    {
      left: {
        title: "02. Promo Indicator",
        content: (
          <div>
            <p>
              Promo is the thing that customers looking for when purchasing, but
              it might be tricky if they don’t get it because the promo is not
              valid or the promo isn’t there anymore. For specific section,
              customer go to the Check out 1 and click on the promo box.
              Unfortunately, they don’t know if there’s any promo or not. After
              we did some research, we got customer’s concern that they don’t
              aware there is a promo or they already tried on the previous
              checkout but didn't find any, so they assumed there is no promo
              available for their current purchasing.{" "}
            </p>

            <p>
              Then we solved this with the promo indicator which showing
              indicator for promo avaiable or potentially to be added on their
              Checkout. And for the output, this improvements increased the CTR
              and the CVR on the promo box!
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: <img alt="" src={Content2} width="100%" />,
      },
      bottomImage: "",
    },
    {
      left: {
        title: "03. Cart Revamp",
        content: (
          <div>
            In terms of sustainbility and user interface improvements, Cart in
            Blibli bring new looks for the products and payment details in much
            more pleasant visuals. Initiated to make that happened on the
            process I analyzed heatmap, did a brainstorming session together,
            and read research report so we can hypotesize the possibility and
            alignment with the user needs on the Checkout.
          </div>
        ),
      },
      bottomImage: Content3,
    },
  ],
} as ProjectDetailProps;
